import './App.css';
import { useEffect, useState } from 'react';
import { fetchWeather } from './api';
import WeatherCard from './Components/WeatherCard';

function App() {
  const [city, setCity] = useState('Hanoi');
  const [weather, setWeather] = useState(null)
  const [error, setError] = useState('')

  const handleChange = (event) => {
    setCity(event.target.value);
  };

  const handleSubmit = async () => {
    // event.preventDefault();
    try {
      const weather = await fetchWeather(city, setError);
      setWeather(weather);
    } catch (error) {
      setError("City not found");
    }
  };
  useEffect(() => {
    handleSubmit()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="App">
      <h1 className='app_heading'>Weather App</h1>
      <div className='form'>
        <input
          type="text"
          placeholder="Enter city"
          // value={city}
          onChange={handleChange}
        />
        <button type="submit" onClick={handleSubmit}>Search</button>
      </div>

      {error ? (
        <p className='error'>{error}</p>
      ) : (
        <WeatherCard weather={weather} />
      )}
    </div>
  );
}

export default App;
